<template>
  <div>
    <md-dialog
      :md-active.sync="showDialog"
      :md-backdrop="true"
      @md-opened="clearData"
      class="setting-user-dialog"
      :md-click-outside-to-close="false"
    >
      <div :class="checkBackdrop ? 'bg-backdrop' : ''"></div>
      <md-dialog-title>
        <div class="title-panel">{{ titleDialog }}</div>
      </md-dialog-title>

      <md-tabs @md-changed="onClickTab">
        <md-tab id="tab-home" md-label="Basic Infomation">
          <div class="md-layout">
            <div class="md-layout-item md-medium-size-50 md-small-size-50">
              <multiselect
                v-model="selectedUser"
                id="ajax-find-user"
                label="displayname"
                track-by="code"
                placeholder="Search users by name, email"
                open-direction="bottom"
                :options="dataSearchUsers"
                :multiple="false"
                :searchable="true"
                :loading="isLoading"
                :close-on-select="true"
                :options-limit="300"
                :max-height="250"
                :show-no-results="false"
                :hide-selected="true"
                :showLabels="false"
                :internal-search="false"
                @search-change="asyncFindUser"
                :disabled="isDisabledSearch"
                @select="onSelect"
                style="z-index:10"
              ></multiselect>
            </div>
            <div class="md-layout-item md-medium-size-50 md-small-size-50">
              <md-field class="md-has-value">
                <label for="username">Username</label>
                <md-input
                  name="username"
                  autocomplete="given-name"
                  v-model="form.username"
                  :disabled="sending"
                  readonly
                />
              </md-field>
            </div>
          </div>

          <div class="md-layout">
            <div
              class="md-layout-item md-medium-size-50 md-small-size-50 -font-kanit"
            >
              <md-field class="md-has-value">
                <label for="first-name">First Name</label>
                <md-input
                  name="first-name"
                  v-model="form.firstname"
                  :disabled="sending"
                  readonly
                />
              </md-field>
            </div>
            <div
              class="md-layout-item md-medium-size-50 md-small-size-50 -font-kanit"
            >
              <md-field class="md-has-value">
                <label for="last-name">Last Name</label>
                <md-input
                  name="last-name"
                  v-model="form.lastname"
                  :disabled="sending"
                  readonly
                />
              </md-field>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-medium-size-50 md-small-size-50">
              <md-field class="md-has-value">
                <label for="email">Email</label>
                <md-input
                  type="email"
                  name="email"
                  v-model="form.email"
                  :disabled="sending"
                  readonly
                />
              </md-field>
            </div>
            <div class="md-layout-item md-medium-size-50 md-small-size-50">
              <!-- <md-field class="md-has-value -password">
                            <label for="password">Password</label>
                            <md-input ref="inputPassword" type="password" name="email" id="password" v-model="form.password" :disabled="sending" />
              </md-field>-->
              <md-field class="md-has-value">
                <label for="movie">Group</label>
                <md-select
                  v-model="form.user_group"
                  name="userGroup"
                  id="userGroup"
                >
                  <md-option value="Admin">Admin</md-option>
                  <md-option value="Manager">Manager</md-option>
                  <md-option value="Trade Marketer">Trade Marketer</md-option>
                  <md-option value="User">User</md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-medium-size-50 md-small-size-50">
              <!-- <md-field class="md-has-value">
                <label for="movie">Group</label>
                <md-select
                  v-model="form.user_group"
                  name="userGroup"
                  id="userGroup"
                >
                  <md-option value="Admin">Admin</md-option>
                  <md-option value="Manager">Manager</md-option>
                  <md-option value="Trade Marketer">Trade Marketer</md-option>
                  <md-option value="User">User</md-option>
                </md-select>
              </md-field> -->
              <md-field class="md-has-value">
                <label for="movie">Role</label>
                <md-select
                  v-model="form.role_type"
                  name="userRole"
                  id="userRole"
                >
                  <md-option value="SALE_CO">SALE_CO</md-option>
                  <md-option value="SALE_MG">SALE_MG</md-option>
                  <md-option value="PMD_MG">PMD_MG</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-medium-size-50 md-small-size-50">
              <md-checkbox class="md-primary" v-model="status"
                >Active</md-checkbox
              >
            </div>
          </div>

          <!-- <div class="md-layout">
            <div class="md-layout-item md-medium-size-50 md-small-size-50">
              <md-field class="md-has-value">
                <label for="movie">Role</label>
                <md-select
                  v-model="form.role_type"
                  name="userRole"
                  id="userRole"
                >
                  <md-option value="SALE_CO">SALE_CO</md-option>
                  <md-option value="SALE_MG">SALE_MG</md-option>
                  <md-option value="PMD_MG">PMD_MG</md-option>
                </md-select>
              </md-field>
            </div>
            <div
              class="md-layout-item md-medium-size-50 md-small-size-50"
            ></div>
          </div> -->
        </md-tab>

        <md-tab id="tab-pages" md-label="Permission">
          <!-- <div id="table-permission">
                    <div id="divTableHead">
                        <div style="width: 13%;">Module</div>
                        <div style="width: 23%">View</div>
                        <div style="width: 19%;">Add</div>
                        <div style="width: 21%;">Edit</div>
                        <div style="width: 15%;">Delete</div>
                        <div style="width: 9%;">Approve</div>
                    </div>
                    <div id="divTableBody">
                        <div :class="'row-bg-gray'" v-for="(item, mIndex) in Modules" :key="mIndex">
                            <div style="width: 13%">{{ item.title }}</div>
                            <div style="width: 23%">
                                <md-checkbox class="md-primary" v-model="permit[getModuleName(item.url)].view" @change="moduleChange(getModuleName(item.url),'view',$event)"></md-checkbox>
                            </div>
                            <div style="width: 19%;">
                                <md-checkbox class="md-primary" v-model="permit[getModuleName(item.url)].add" @change="moduleChange(getModuleName(item.url),'add',$event)"></md-checkbox>
                            </div>
                            <div style="width: 21%;">
                                <md-checkbox class="md-primary" v-model="permit[getModuleName(item.url)].edit" @change="moduleChange(getModuleName(item.url),'edit',$event)"></md-checkbox>
                            </div>
                            <div style="width: 15%;">
                                <md-checkbox class="md-primary" v-model="permit[getModuleName(item.url)].delete" @change="moduleChange(getModuleName(item.url),'delete',$event)"></md-checkbox>
                            </div>
                            <div style="width: 9%;">
                                <md-checkbox class="md-primary" v-model="permit[getModuleName(item.url)].approve" @change="moduleChange(getModuleName(item.url),'approve',$event)"></md-checkbox>
                            </div>

                            <div v-for="(subitem, sIndex) in item.sub" :key="sIndex">
                                <div style="width: 13%">{{ subitem.title }}</div>
                                <div style="width: 23%">
                                    <md-checkbox class="md-primary" v-model="permit[getModuleName(item.url)].menus[getMenuName(subitem.url)].view" @change="menuChange(getModuleName(item.url),getMenuName(subitem.url),'view',$event)"></md-checkbox>
                                </div>
                                <div style="width: 19%;">
                                    <md-checkbox class="md-primary" v-model="permit[getModuleName(item.url)].menus[getMenuName(subitem.url)].add" @change="menuChange(getModuleName(item.url),getMenuName(subitem.url),'add',$event)"></md-checkbox>
                                </div>
                                <div style="width: 21%;">
                                    <md-checkbox class="md-primary" v-model="permit[getModuleName(item.url)].menus[getMenuName(subitem.url)].edit" @change="menuChange(getModuleName(item.url),getMenuName(subitem.url),'edit',$event)"></md-checkbox>
                                </div>
                                <div style="width: 15%;">
                                    <md-checkbox class="md-primary" v-model="permit[getModuleName(item.url)].menus[getMenuName(subitem.url)].delete" @change="menuChange(getModuleName(item.url),getMenuName(subitem.url),'delete',$event)"></md-checkbox>
                                </div>
                                <div style="width: 9%;">
                                    <md-checkbox class="md-primary" v-model="permit[getModuleName(item.url)].menus[getMenuName(subitem.url)].approve" @change="menuChange(getModuleName(item.url),getMenuName(subitem.url),'approve',$event)"></md-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
          </div>-->
          <div class="div-cover-table">
            <table id="table-permission">
              <thead>
                <th>Module</th>
                <th>View</th>
                <th>Add</th>
                <th>Edit</th>
                <th>Delete</th>
                <th>Approve</th>
                <th>Export</th>
              </thead>
              <!-- <div id="divTableHead">
                        <div style="width: 13%;">Module</div>
                        <div style="width: 23%">View</div>
                        <div style="width: 19%;">Add</div>
                        <div style="width: 21%;">Edit</div>
                        <div style="width: 15%;">Delete</div>
                        <div style="width: 9%;">Approve</div>
              </div>-->
              <tbody>
                <template v-for="item in Modules">
                  <tr class="background-module">
                    <td class="module">{{ item.title }}</td>
                    <td width="100px;" class="-checkbox">
                      <md-checkbox
                        class="md-primary"
                        v-model="permit[getModuleName(item.url)].view"
                        @change="
                          moduleChange(getModuleName(item.url), 'view', $event)
                        "
                      ></md-checkbox>
                    </td>
                    <td width="100px;" class="-checkbox">
                      <md-checkbox
                        class="md-primary"
                        v-model="permit[getModuleName(item.url)].add"
                        @change="
                          moduleChange(getModuleName(item.url), 'add', $event)
                        "
                      ></md-checkbox>
                    </td>
                    <td width="100px;" class="-checkbox">
                      <md-checkbox
                        class="md-primary"
                        v-model="permit[getModuleName(item.url)].edit"
                        @change="
                          moduleChange(getModuleName(item.url), 'edit', $event)
                        "
                      ></md-checkbox>
                    </td>
                    <td width="100px;" class="-checkbox">
                      <md-checkbox
                        class="md-primary"
                        v-model="permit[getModuleName(item.url)].delete"
                        @change="
                          moduleChange(
                            getModuleName(item.url),
                            'delete',
                            $event
                          )
                        "
                      ></md-checkbox>
                    </td>
                    <td width="100px;" class="-checkbox">
                      <md-checkbox
                        class="md-primary"
                        v-model="permit[getModuleName(item.url)].approve"
                        @change="
                          moduleChange(
                            getModuleName(item.url),
                            'approve',
                            $event
                          )
                        "
                      ></md-checkbox>
                    </td>
                    <td width="100px;" class="-checkbox">
                      <!--<md-checkbox class="md-primary" disable="(item.title != Pricing List)? disable : false" v-model="permit[getModuleName(item.url)].export" @change="moduleChange(getModuleName(item.url),'export',$event)"></md-checkbox>-->
                    </td>
                  </tr>
                  <template v-for="subitem in item.sub">
                    <tr>
                      <td class="sub-item">{{ subitem.title }}</td>
                      <td width="100px;" class="-checkbox">
                        <md-checkbox
                          class="md-primary"
                          v-model="
                            permit[getModuleName(item.url)].menus[
                              getMenuName(subitem.url)
                            ].view
                          "
                          @change="
                            menuChange(
                              getModuleName(item.url),
                              getMenuName(subitem.url),
                              'view',
                              $event
                            )
                          "
                        ></md-checkbox>
                      </td>
                      <td width="100px;" class="-checkbox">
                        <md-checkbox
                          class="md-primary"
                          v-model="
                            permit[getModuleName(item.url)].menus[
                              getMenuName(subitem.url)
                            ].add
                          "
                          @change="
                            menuChange(
                              getModuleName(item.url),
                              getMenuName(subitem.url),
                              'add',
                              $event
                            )
                          "
                        ></md-checkbox>
                      </td>
                      <td width="100px;" class="-checkbox">
                        <md-checkbox
                          class="md-primary"
                          v-model="
                            permit[getModuleName(item.url)].menus[
                              getMenuName(subitem.url)
                            ].edit
                          "
                          @change="
                            menuChange(
                              getModuleName(item.url),
                              getMenuName(subitem.url),
                              'edit',
                              $event
                            )
                          "
                          :disabled="
                            subitem.title == 'Book Price' ? true : false
                          "
                        ></md-checkbox>
                      </td>
                      <td width="100px;" class="-checkbox">
                        <md-checkbox
                          class="md-primary"
                          v-model="
                            permit[getModuleName(item.url)].menus[
                              getMenuName(subitem.url)
                            ].delete
                          "
                          @change="
                            menuChange(
                              getModuleName(item.url),
                              getMenuName(subitem.url),
                              'delete',
                              $event
                            )
                          "
                        ></md-checkbox>
                      </td>
                      <td width="100px;" class="-checkbox">
                        <md-checkbox
                          class="md-primary"
                          v-model="
                            permit[getModuleName(item.url)].menus[
                              getMenuName(subitem.url)
                            ].approve
                          "
                          @change="
                            menuChange(
                              getModuleName(item.url),
                              getMenuName(subitem.url),
                              'approve',
                              $event
                            )
                          "
                          :disabled="
                            subitem.title == 'Book Price' ? true : false
                          "
                        ></md-checkbox>
                      </td>
                      <td width="100px;" class="-checkbox">
                        <md-checkbox
                          class="md-primary"
                          v-show="
                            subitem.title == 'Pricing List' ||
                              subitem.title == 'Book Price'
                          "
                          v-model="
                            permit[getModuleName(item.url)].menus[
                              getMenuName(subitem.url)
                            ].export
                          "
                          @change="
                            menuChange(
                              getModuleName(item.url),
                              getMenuName(subitem.url),
                              'export',
                              $event
                            )
                          "
                        ></md-checkbox>
                      </td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </table>
          </div>
        </md-tab>

        <md-tab id="tab-approve" md-label="Approval">
          <!-- <div
            class="-head"
            v-if="
              this.userInfo.firstname !== '' && this.userInfo.lastname !== ''
            "
          >
            {{ userInfo.firstname }} {{ userInfo.lastname }}
          </div>-->
          <div
            v-if="
              this.userInfo.firstname === '' || this.userInfo.lastname === ''
            "
            class="-head"
            style="color: rgb(154, 154, 154);"
          >
            Please select users from tab "BASIC INFOMATION"
          </div>

          <!-- <hr
            v-show="
              this.userInfo.firstname !== '' && this.userInfo.lastname !== ''
            "
            class="hr-head"
            style="margin: 0px 30px; opacity: 0.2;"
          />-->

          <div
            class="-body -font-kanit"
            v-show="
              this.userInfo.firstname !== '' && this.userInfo.lastname !== ''
            "
          >
            <div class="-detail">
              <div class="-empty"></div>
              <div class="-data">
                <multiselect
                  style="width: 100%;"
                  v-model="selectedPeople"
                  label="firstname"
                  track-by="code"
                  placeholder="+ Add Approval Name"
                  :open-direction="'bottom'"
                  :options="optionsPeople"
                  :searchable="true"
                  :max-height="180"
                  :show-no-results="false"
                  :custom-label="customLabelPeople"
                  :select-label="''"
                  :deselect-label="''"
                  :selected-label="''"
                  :hide-selected="true"
                  @select="setDataSave"
                  @close="onCloseMultisel"
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    <div>
                      <div class="-label">
                        {{ option.firstname }} {{ option.lastname }}
                      </div>
                      <!-- <div
                    class="-delete"
                    @mousedown.prevent.stop="clearAll(option.code)"
                    >
                    <i class="material-icons">close</i>
                      </div>-->
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>

            <div
              class="-detail"
              v-show="defaultFirstname !== '' && defaultLastname !== ''"
            >
              <div class="-empty"></div>
              <div class="-data">
                {{ defaultFirstname }} {{ defaultLastname }}
              </div>
              <div style="margin-left: 25px;">
                <md-icon style="color: gray;" title="Role approve from my hr"
                  >person</md-icon
                >
              </div>
            </div>

            <!-- v-for="(item, index) in userInfo.select" -->
            <div
              class="-detail"
              v-for="(item, index) in userInfoSelect"
              :key="index"
            >
              <div class="-empty"></div>
              <div class="-data">{{ item.firstname }} {{ item.lastname }}</div>
              <div style="margin-left: 25px;">
                <md-icon title="Delete" style="color: red; cursor: pointer;">
                  <span @click="deleteRow(index)">remove_circle</span>
                </md-icon>
              </div>
            </div>

            <!-- <div
              class="-detail"
              v-for="(item, index) in userInfo.data_approve"
              :key="index"
            >
              <div class="-empty"></div>
              <div class="-data">
                <label> {{ item.firstname }} {{ item.lastname }} </label>
              </div>
              <div style="margin-left: 25px;">
                <md-icon
                  v-show="item.type === 'config'"
                  title="Delete"
                  style="color: red; cursor: pointer;"
                  ><span @click="deleteRow(index)">
                    remove_circle
                  </span>
                </md-icon>
              </div>
            </div>-->
          </div>
        </md-tab>

        <md-tab id="tab-view-promotion" md-label="View Promotion">
          <div
            v-if="
              this.userInfo.firstname === '' || this.userInfo.lastname === ''
            "
            class="-head"
            style="color: rgb(154, 154, 154);"
          >
            Please select users from tab "BASIC INFOMATION"
          </div>

          <div v-else class="-font-kanit" style="margin: 10px 50px 0px 50px;">
            กำหนดสิทธิ์การมองเห็น Promotion By User Create
          </div>

          <div class="-body -font-kanit" id="promo">
            <div>
              <div class="-detail">
                <div class="-empty"></div>
                <div class="-data">
                  <multiselect
                    style="width: 100%;"
                    v-model="selectedPeoplePromo"
                    label="firstname"
                    track-by="code"
                    placeholder="+ Add Name"
                    :open-direction="'bottom'"
                    :options="optionsPeoplePromo"
                    :searchable="true"
                    :max-height="180"
                    :show-no-results="false"
                    :custom-label="customLabelPeople"
                    :select-label="''"
                    :deselect-label="''"
                    :selected-label="''"
                    :hide-selected="true"
                    @select="setDataSavePromo"
                    @close="onCloseMultiselPromo"
                  >
                    <template slot="singleLabel" slot-scope="{ option }">
                      <div>
                        <div class="-label">
                          {{ option.firstname }} {{ option.lastname }}
                        </div>
                      </div>
                    </template>
                  </multiselect>
                </div>
              </div>

              <div
                class="-detail"
                v-for="(data, key) in userInfo.default_under"
                :key="key"
              >
                <div class="-empty"></div>
                <div class="-data">
                  {{ data.firstname }} {{ data.lastname }}
                </div>
                <div style="margin-left: 25px;">
                  <md-icon style="color: gray;" title="Role from my hr"
                    >person</md-icon
                  >
                </div>
              </div>
            </div>

            <div>
              <div
                class="-detail"
                v-for="(item, pmIndex) in userInfoSelectPromo"
                :key="pmIndex"
              >
                <div class="-empty"></div>
                <div class="-data">
                  {{ item.firstname }} {{ item.lastname }}
                </div>
                <div style="margin-left: 25px;">
                  <md-icon title="Delete" style="color: red; cursor: pointer;">
                    <span @click="deleteRowPromo(pmIndex)">remove_circle</span>
                  </md-icon>
                </div>
              </div>
            </div>
          </div>
        </md-tab>
      </md-tabs>

      <md-dialog-actions class="-action">
        <md-button class="-cancel" @click="onClickClose()">CLOSE</md-button>
        <md-button class="md-primary -confirm" @click="onSaveUser()"
          >SAVE</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <!-- <md-dialog-alert :md-active.sync="showAlert" :md-title="alertTitle" :md-content="alertContent" /> -->
    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ dContent }}</span>
      <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>

    <md-dialog-confirm
      :md-active.sync="showConfirmSave"
      :md-content="dlgConfirmContent"
      md-confirm-text="ok"
      md-cancel-text="close"
      @md-cancel="onCancel"
      @md-confirm="onConfirmSave"
    />
    <md-dialog-confirm
      :md-active.sync="showDialogCancel"
      :md-click-outside-to-close="false"
      md-content="Are you sure you want to close ?"
      md-confirm-text="OK"
      md-cancel-text="CANCEL"
      @md-cancel="onCancel"
      @md-confirm="onConfirm"
    />
  </div>
</template>

<script>
var _ = require("lodash");
import Vue from "vue";
import CipherService from "@/services/cipher";

import UserService from "@/services/user";
export default {
  name: "user-form",
  props: {
    Info: {
      type: Object
    }
  },
  data() {
    return {
      userInfoSelect: [],
      selectedPeople: [],
      optionsPeople: [],
      userInfoSelectPromo: [],
      selectedPeoplePromo: [],
      optionsPeoplePromo: [],
      position: "center",
      duration: 20000,
      isInfinity: false,
      dContent: "",
      showSnackbar: false,
      checkBackdrop: false,
      showDialogCancel: false,
      showDialog: false,
      mode: "add",
      titleDialog: "Create a new user",
      isLoading: false,
      selectedUser: null,
      sending: false,
      status: true,
      form: {
        username: null,
        firstname: null,
        lastname: null,
        email: null,
        password: null,
        user_status: "Active",
        user_group: "User",
        role_type: ""
      },
      dataSearchUsers: [],
      userInfo: {},
      isDisabledSearch: false,
      Modules: [],
      permit: {},

      showAlert: false,
      alertTitle: "",
      alertContent: "",

      showConfirmSave: false,
      dlgConfirmContent: "",
      defaultFirstname: "",
      defaultLastname: ""
    };
  },
  watch: {
    Info: "insertData"
  },
  computed: {
    //   status(){
    //       if(this.form.user_status == 'Active') return true;
    //       else return false;
    //   }
  },
  created() {
    this.getModule();
  },
  methods: {
    onClickTab(value) {
      // if (
      //   value === "tab-approve" &&
      //   this.userInfo.firstname === "" &&
      //   this.userInfo.lastname === ""
      // ) {
      //   this.alertTitle = "Alert";
      //   this.dContent = 'Please select users from tab "BASIC INFOMATION"';
      //   this.showSnackbar = true;
      //   return false;
      // }
    },
    customLabelPeople({ firstname, lastname }) {
      return `${firstname} ${lastname}`;
    },
    clearAll(id, type) {
      this.selectedPeople = [];
    },
    setDataSave(selectedOption) {
      let index = this.optionsPeople.findIndex(
        item => item.code === selectedOption.code
      );
      if (index > -1) {
        this.optionsPeople.splice(index, 1);
        // this.userInfo.select.push(selectedOption);
        this.userInfoSelect.push(selectedOption);
      }
    },
    setDataSavePromo(selectedOption) {
      let index = this.optionsPeoplePromo.findIndex(
        item => item.code === selectedOption.code
      );
      if (index > -1) {
        this.optionsPeoplePromo.splice(index, 1);
        this.userInfoSelectPromo.push(selectedOption);
      }
    },
    onCloseMultisel() {
      this.selectedPeople = [];
    },
    onCloseMultiselPromo() {
      this.selectedPeoplePromo = [];
    },
    deleteRow(index) {
      this.optionsPeople.push(this.userInfoSelect[index]);
      this.userInfoSelect.splice(index, 1);
    },
    deleteRowPromo(index) {
      this.optionsPeoplePromo.push(this.userInfoSelectPromo[index]);
      this.userInfoSelectPromo.splice(index, 1);
    },
    onConfirm() {
      this.checkBackdrop = false;
      this.showDialog = false;
      this.showDialogCancel = false;
    },
    onCancel() {
      this.checkBackdrop = false;
    },
    onClickClose() {
      this.checkBackdrop = true;
      this.showDialogCancel = true;
    },
    moduleChange(menu, action, event) {
      if (event == true) {
        if (action == "add" || action == "edit" || action == "delete") {
          this.permit[menu].view = true;
        }

        for (var k in this.permit[menu].menus) {
          if (
            menu === "overview" &&
            k === "book-price" &&
            (action === "edit" || action === "approve")
          ) {
          } else {
            this.permit[menu].menus[k][action] = true;
            if (action == "add" || action == "edit" || action == "delete") {
              this.permit[menu].menus[k].view = true;
            }
          }
        }
      } else {
        for (var k in this.permit[menu].menus) {
          if (
            menu === "overview" &&
            k === "book-price" &&
            (action === "edit" || action === "approve")
          ) {
          } else {
            this.permit[menu].menus[k][action] = false;
          }
        }
      }
    },
    menuChange(module, menu, action, event) {
      if (
        event == true &&
        (action == "add" || action == "edit" || action == "delete")
      ) {
        this.permit[module].view = true;
        this.permit[module].menus[menu].view = true;

        if (action == "add") {
          this.permit[module].add = true;
          if (module === "overview" && menu === "book-price") {
            this.permit[module].edit = true;
            this.permit[module].approve = true;
            this.permit["overview"].menus["book-price"].edit = true;
            this.permit["overview"].menus["book-price"].approve = true;
          }
        } else if (action == "edit") {
          this.permit[module].edit = true;
        } else if (action == "delete") {
          this.permit[module].delete = true;
        }
      } else if (
        !event &&
        action === "add" &&
        module === "overview" &&
        menu === "book-price"
      ) {
        this.permit["overview"].menus["book-price"].edit = false;
        this.permit["overview"].menus["book-price"].approve = false;
      }

      if (event == true && action == "view") {
        this.permit[module].view = true;
      } else if (event == false && action == "view") {
        this.permit[module].menus[menu].add = false;
        this.permit[module].menus[menu].edit = false;
        this.permit[module].menus[menu].delete = false;
      }

      if (event == true && action == "approve") {
        this.permit[module].approve = true;
      }

      if (event == true && action == "export") {
        this.permit[module].export = true;
      }
    },

    clearData() {
      // this.permit = {};
      if (this.mode == "add") {
        this.userInfo.firstname = "";
        this.userInfo.lastname = "";
        this.defaultFirstname = "";
        this.defaultLastname = "";
        this.userInfoSelect = [];
        this.userInfoSelectPromo = [];

        this.Modules.forEach(module => {
          Vue.set(this.permit, this.getModuleName(module.url), {
            view: false,
            add: false,
            edit: false,
            delete: false,
            approve: false,
            export: false
          });
          var m = {};
          module.sub.forEach(menus => {
            Vue.set(m, this.getMenuName(menus.url), {
              view: false,
              add: false,
              edit: false,
              delete: false,
              approve: false,
              export: false
            });
          });
          Vue.set(this.permit[this.getModuleName(module.url)], "menus", m);
        });
      } else {
        this.Modules.forEach(module => {
          Vue.set(this.permit, this.getModuleName(module.url), {
            view: false,
            add: false,
            edit: false,
            delete: false,
            approve: false,
            export: false
          });
          var m = {};
          module.sub.forEach(menus => {
            Vue.set(m, this.getMenuName(menus.url), {
              view: false,
              add: false,
              edit: false,
              delete: false,
              approve: false,
              export: false
            });
          });
          Vue.set(this.permit[this.getModuleName(module.url)], "menus", m);
        });
        _.merge(this.permit, this.Info.acl_module);
      }

      this.form.password = "";
    },
    getModuleName(url) {
      return url.split("/")[1];
    },
    getMenuName(url) {
      return url.split("/")[2]; //.replace("-", '_');
    },
    getModule() {
      UserService.getAllModule()
        .then(response => {
          if (this.mode == "add") {
            response.forEach(module => {
              Vue.set(this.permit, this.getModuleName(module.url), {
                view: false,
                add: false,
                edit: false,
                delete: false,
                approve: false,
                export: false
              });
              var m = {};
              module.sub.forEach(menus => {
                Vue.set(m, this.getMenuName(menus.url), {
                  view: false,
                  add: false,
                  edit: false,
                  delete: false,
                  approve: false,
                  export: false
                });
              });
              Vue.set(this.permit[this.getModuleName(module.url)], "menus", m);
            });
          } else {
            this.permit = this.Info.acl_module;
          }

          this.Modules = response;
        })
        .catch(error => console.log(error));
    },
    insertData() {
      this.userInfo = this.Info;
      this.userInfoSelect = this.Info.select;
      this.userInfoSelectPromo = this.Info.select_promo;

      /* TAB APPROVAL */
      this.defaultFirstname = this.userInfo.default.firstname
        ? this.userInfo.default.firstname
        : "";
      this.defaultLastname = this.userInfo.default.lastname
        ? this.userInfo.default.lastname
        : "";

      this.form.username = this.Info.username;
      this.form.firstname = this.Info.firstname;
      this.form.lastname = this.Info.lastname;
      this.form.email = this.Info.email;
      this.form.user_group = this.Info.user_group;
      this.form.role_type = this.Info.role_type;
      this.isDisabledSearch = true;

      //this.form.permission = this.Info.acl_module;
      // this.getModule();
      // this.permit = this.Info.acl_module;
      //  console.log('old permit',this.permit)
      // console.log('acl',this.Info.acl_module)
      _.merge(this.permit, this.Info.acl_module);
      // console.log('new permit',this.permit)

      if (this.Info.status == "active") this.status = true;
      else this.status = false;

      let self = this;
      UserService.getUserConfig().then(response => {
        if (response && response.length > 0) {
          self.optionsPeople = response;
          self.optionsPeoplePromo = _.clone(response);

          let code_user = response.findIndex(
            item => item.code === self.userInfo.code
          );
          if (code_user > -1) {
            self.optionsPeople.splice(code_user, 1);
            self.optionsPeoplePromo.splice(code_user, 1);
          }

          /* TAB APPROVAL */
          let key = response.findIndex(
            item => item.code === self.userInfo.default.code
          );
          if (key > -1) {
            self.optionsPeople.splice(key, 1);
          }
          /* TAB VIEW PROMOTION */
          // console.log("self.userInfo ==>", self.userInfo);
          let removedItems = [];
          for (let i = 0; i < self.userInfo.default_under.length; i++) {
            let currentCode = self.userInfo.default_under[i].code;
            // let keypm = response.findIndex(
            //   item => item.code === self.userInfo.default_under[i].code
            // );
            let keypm = self.optionsPeoplePromo.findIndex(
              item => item.code === currentCode
            );
            if (keypm > -1) {
              // self.optionsPeoplePromo.splice(keypm, 1);
              let removed = self.optionsPeoplePromo.splice(keypm, 1); 
              removedItems.push(removed[0]);
            }
          }
          // console.log("Removed items:", removedItems);
          // console.log("self.optionsPeoplePromo ==>", self.optionsPeoplePromo);

          /* TAB APPROVAL */
          for (let i = 0; i < self.userInfo.select.length; i++) {
            let index = response.findIndex(
              item => item.code === self.userInfo.select[i].code
            );
            if (index > -1) {
              self.optionsPeople.splice(index, 1);
            }
          }
          /* TAB VIEW PROMOTION */
          // for (let i = 0; i < self.userInfo.select_promo.length; i++) {
          //   let indexpm = response.findIndex(
          //     item => item.code === self.userInfo.select_promo[i].code
          //   );
          //   if (indexpm > -1) {
          //     self.optionsPeoplePromo.splice(indexpm, 1);
          //   }
          // }
          for (let i = 0; i < self.userInfo.select_promo.length; i++) {
            let currentCode = self.userInfo.select_promo[i].code;
            let indexpm = self.optionsPeoplePromo.findIndex(
              item => item.code === currentCode
            );

            if (indexpm > -1) {
              self.optionsPeoplePromo.splice(indexpm, 1);
            }
          }
        }
        // console.log("self.optionsPeoplePromo ==>", self.optionsPeoplePromo);
      });
    },
    asyncFindUser(keyword) {
      if (keyword != "") {
        CipherService.searchUser(keyword)
          .then(response => {
            this.dataSearchUsers = response.resource;
            // this.$forceUpdate()
          })
          .catch(error => console.log(error));
      }
    },

    onSelect(item) {
      if (item.code) {
        UserService.checkDuplicate(item.code).then(res => {
          if (res === true) {
            this.selectedUser = null;

            this.form = {
              username: "",
              firstname: "",
              lastname: "",
              email: "",
              password: "",
              user_status: "Active",
              user_group: "User",
              role_type: ""
            };
            // alert('duplicate');

            this.alertTitle = "Alert";
            // this.alertContent = "Plelse select user.";
            this.dContent = "User already exists.";
            // this.showAlert = true;
            this.showSnackbar = true;
          } else {
            CipherService.getUserInfo(item.code)
              .then(async response => {
                this.userInfo = response.resource[0];

                this.form.username = this.userInfo.username;
                this.form.firstname = this.userInfo.firstname;
                this.form.lastname = this.userInfo.lastname;
                this.form.email = this.userInfo.email;

                let datas = {
                  code: response.resource[0].code,
                  boss_code: response.resource[0].boss_code
                };
                // let dataApproval = await UserService.getUserApproval(datas);
                /* TAB APPROVAL */
                await UserService.getUserApproval(datas).then(rsapproval => {
                  this.userInfo["default"] = rsapproval.default
                    ? rsapproval.default
                    : [];
                  this.userInfo["select"] = rsapproval.select
                    ? rsapproval.select
                    : [];

                  this.defaultFirstname = this.userInfo.default.firstname
                    ? this.userInfo.default.firstname
                    : "";
                  this.defaultLastname = this.userInfo.default.lastname
                    ? this.userInfo.default.lastname
                    : "";

                  UserService.getUserConfig().then(rs => {
                    if (rs && rs.length > 0) {
                      this.optionsPeople = rs;

                      let code_user = rs.findIndex(
                        items => items.code === item.code
                      );
                      if (code_user > -1) {
                        this.optionsPeople.splice(code_user, 1);
                      }

                      let key = rs.findIndex(
                        item => item.code === this.userInfo.default.code
                      );
                      if (key > -1) {
                        this.optionsPeople.splice(key, 1);
                      }

                      for (let i = 0; i < this.userInfo.select.length; i++) {
                        let index = rs.findIndex(
                          item => item.code === this.userInfo.select[i].code
                        );
                        if (index > -1) {
                          this.optionsPeople.splice(index, 1);
                        }
                      }
                    }
                  });
                });

                /* TAB VIEW PROMOTION */
                await UserService.getUserUnder(response.resource[0].code).then(
                  rsviewpromo => {
                    this.userInfo["default_under"] = rsviewpromo.default_under
                      ? rsviewpromo.default_under
                      : [];
                    this.userInfo["select_promo"] = rsviewpromo.select_promo
                      ? rsviewpromo.select_promo
                      : [];

                    UserService.getUserConfig().then(rs => {
                      if (rs && rs.length > 0) {
                        this.optionsPeoplePromo = rs;

                        let code_user = rs.findIndex(
                          items => items.code === item.code
                        );
                        if (code_user > -1) {
                          this.optionsPeoplePromo.splice(code_user, 1);
                        }

                        for (
                          let i = 0;
                          i < this.userInfo.default_under.length;
                          i++
                        ) {
                          let keypm = rs.findIndex(
                            item =>
                              item.code === this.userInfo.default_under[i].code
                          );
                          if (keypm > -1) {
                            this.optionsPeoplePromo.splice(keypm, 1);
                          }
                        }

                        for (
                          let i = 0;
                          i < this.userInfo.select_promo.length;
                          i++
                        ) {
                          let index = rs.findIndex(
                            item =>
                              item.code === this.userInfo.select_promo[i].code
                          );
                          if (index > -1) {
                            this.optionsPeoplePromo.splice(index, 1);
                          }
                        }
                      }
                    });
                  }
                );

                this.showSnackbar = false;
              })
              .catch(error => console.log(error));
          }
        });
      }
    },
    clearForm() {
      // this.$v.$reset()
      this.form.username = null;
      this.form.firstname = null;
      this.form.lastname = null;
      this.form.email = null;
      this.form.password = null;
      this.form.code = null;
      this.form.user_group = "User";
      this.form.role_type = null;
      (this.selectedUser = null), (this.isDisabledSearch = false);
    },
    onSaveUser() {
      //console.log(this.form)
      if (this.status == true) this.userInfo.status = "active";
      else this.userInfo.status = "inactive";

      this.userInfo.user_group = this.form.user_group;
      this.userInfo.role_type = this.form.role_type;

      if (this.mode == "add") {
        if (this.form.username == null || this.form.username == "") {
          this.alertTitle = "Alert";
          // this.alertContent = "Plelse select user.";
          this.dContent = "Plelse select user.";
          // this.showAlert = true;
          this.showSnackbar = true;
          return;
        }

        // if (this.form.password == "") {
        //     this.alertTitle = "Alert";
        //     // this.alertContent = "Plelse input password.";
        //     this.dContent = "Plelse input password.";
        //     // this.showAlert = true;
        //     this.showSnackbar = true;
        //     this.$refs.inputPassword.$el.focus();
        //     return;
        // }

        // if (this.form.password.length < 4) {
        //     this.alertTitle = "Alert";
        //     // this.alertContent = "Password must be at least 4 characters.";
        //     this.dContent = "Password must be at least 4 characters.";
        //     // this.showAlert = true;
        //     this.showSnackbar = true;
        //     this.$refs.inputPassword.$el.focus();
        //     return;
        // }

        this.userInfo.password = this.form.password;
        this.userInfo.acl_module = this.permit;
        this.userInfo.select = this.userInfoSelect;
        this.userInfo.select_promo = this.userInfoSelectPromo;

        //this.$emit("onSave", this.userInfo);

        this.dlgConfirmContent = "Are you sure you want to save ?";
        this.showConfirmSave = true;
        this.checkBackdrop = true;
      } else {
        if (this.form.password) {
          this.userInfo.password = this.form.password;
        }

        this.userInfo.acl_module = this.permit;

        this.dlgConfirmContent = "Are you sure you want to save changes ?";
        this.showConfirmSave = true;
        this.checkBackdrop = true;
        //this.$emit("onUpdate", this.userInfo);
      }

      //   this.showDialog = false;
    },
    onConfirmSave() {
      this.checkBackdrop = false;
      if (this.mode == "add") {
        this.$emit("onSave", this.userInfo);
      } else if (this.mode == "edit") {
        this.$emit("onUpdate", this.userInfo);
      }
      //   this.showDialog = false;
      //            this.dContent = "Are you sure you want to save ?";
      //} else {
      //Edit
      //    this.dContent = "Are you sure you want to save changes ?";
    },
    // saveInfo() {
    //   if (this.value.data.status == true) this.value.data.status = "Active";
    //   else this.value.data.status = "Inactive";
    //   this.$emit("onSave", this.value.data);
    //   this.value.showPanel = false;
    // },
    // onConfirmDelete() {
    //   this.$emit("onDelete", this.value.data._id);
    //   this.value.showPanel = false;
    // },
    // cancel() {
    //   this.value.showPanel = false;
    // },
    setValue() {
      // console.log('set value')
      //   if (this.value.data.status == "Active") this.status = true;
      //   else this.status = false;
    }
  }
};
</script>

<style lang="scss">
.setting-user-dialog {
  width: 70%;
  height: 80%;
  z-index: 6 !important;
  transform: unset !important;
  top: 10% !important;
  left: 15% !important;

  .md-dialog-container {
    width: 100%;
  }

  .layout-dialog {
    margin: 0 18px 10px 25px;

    .md-layout {
      &.-head {
        padding-top: 10px;
        padding-left: 5px;
        height: 70px;

        .checkbox-status {
          padding-left: 25px;
          padding-top: 10px;
        }
      }

      &.-update {
        margin-top: 26px;
      }
    }
  }

  .md-dialog-title {
    &.md-title {
      font-size: 18px;
      margin-bottom: 30px;
      padding: 24px 30px 10px;
    }

    .title-panel {
      position: fixed;
    }

    .md-menu {
      width: 102%;
      text-align: right;

      .more-vert {
        height: 25px;
        width: 25px;
        min-width: 25px;
      }
    }
  }

  .md-tabs {
    margin-top: 5px;

    .-font-kanit {
      font-size: 15px !important;
      font-family: kanit;
      font-weight: 300;
    }

    #tab-home {
      margin-top: 12px;
    }

    .md-button,
    .md-ripple {
      height: 35px;
    }

    .md-tabs-navigation {
      border-bottom: 1px solid rgba(128, 128, 128, 0.25);
    }

    .md-layout-item {
      padding-right: 15px;
      padding-left: 15px;

      .multiselect {
        margin-top: 12px;
      }

      .-password {
        .md-button {
          margin-top: 13px;
          height: 33px !important;
        }
      }

      .md-checkbox {
        margin-top: 25px;
      }
    }

    #tab-pages {
      .div-cover-table {
        height: calc(80vmin - 170px);
        overflow-y: auto;

        &::-webkit-scrollbar {
          height: 7px;
          width: 8px;
        }
      }

      #table-permission {
        border-collapse: collapse;
        width: 100%;

        th,
        td {
          padding: 5px 8px;
          text-align: left;
          // border-bottom: 1px solid #ddd;

          &.-checkbox {
            padding-top: 7px;
            padding-bottom: 3px;
          }
        }

        tr:hover {
          background-color: #f5f5f5;
        }

        .md-checkbox {
          margin: 0px !important;
        }

        .module {
          font-weight: bold;
        }

        .background-mobule {
          background-color: red;
        }

        .sub-item {
          padding-left: 30px;
        }

        // #divTableHead {
        //     width: 99.3%;
        //     display: -webkit-inline-box;
        //     font-size: 13px;
        //     font-weight: bold;
        //     margin-top: 15px;
        //     margin-bottom: 10px;

        //     div {
        //         // border: 1px solid pink;
        //         padding-left: 5px;
        //         padding-right: 5px;

        //         &.-text-right {
        //             text-align: right;
        //         }

        //         &.-text-center {
        //             text-align: center;
        //         }
        //     }
        // }

        // tbody {
        //     width: 100%;
        //     height: calc(100vmin - 131px);
        //     // display: block;
        //     overflow-y: scroll;
        //     font-size: 13px;

        //     &::-webkit-scrollbar {
        //         height: 7px;
        //         width: 8px;
        //     }
        // }
      }
    }
  }

  .-action {
    position: fixed;
    padding: 8px 20px 10px 24px;
    bottom: 0px;
    margin-right: auto;
    margin-left: auto;
    width: 100%;

    .md-button {
      margin-right: 0px !important;
    }

    .md-ripple {
      width: 100%;
      margin: 0;
    }

    .-cancel {
      color: #727272 !important;
      margin-right: 10px;
    }
  }

  .bg-backdrop {
    background: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 7;
    top: 0;
    left: 0;
  }
}

.setting-user-info-dialog #tab-approve,
.setting-user-info-dialog #tab-view-promotion,
.setting-user-dialog #tab-approve,
.setting-user-dialog #tab-view-promotion {
  .-head {
    padding: 15px 30px;
  }

  .-body {
    padding: 12px 30px 10px 30px;
    height: calc(80vmin - 185px);
    overflow-y: auto;

    &#promo {
      height: calc(80vmin - 210px) !important;
    }

    &::-webkit-scrollbar {
      height: 7px;
      width: 5px;
    }
  }

  .-detail {
    padding: 10px 30px;
    display: flex;

    .-empty {
      width: 15%;
    }
    .-data {
      width: 30%;
      padding-top: 3px;

      label {
        margin-left: 15px;
      }
    }
  }

  .multiselect {
    .z-index-top {
      z-index: 10;
    }

    margin: 5px 0px;

    .multiselect__single,
    .multiselect__input {
      font-size: 14px;

      div {
        display: flex;
        width: 100%;

        .-delete {
          width: 10%;

          .material-icons {
            font-size: 18px;
            margin-top: 1px;
            cursor: pointer;
            color: gray;
          }
        }
      }
    }

    .multiselect__tags {
      padding: 8px 30px 0 8px;

      input {
        font-family: lato;
        font-weight: 300;
      }

      .multiselect__placeholder {
        margin: 0px;
      }

      ::placeholder {
        color: #bdbdbd;
        opacity: 1;
      }
    }

    .multiselect__content-wrapper,
    .multiselect__content {
      font-size: 14px;
      z-index: 100;
    }

    .multiselect__option {
      min-height: 34px;
      padding: 12px 12px 0px 12px;
    }

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
  }
}
</style>
